import { CvTemplateOutput } from 'document/model/cv-template.output';
import { CvTemplate } from 'domain/template/cv/cv-template';

export abstract class CvTemplateConverterPort {
	public abstract cvTemplateAsEntity(output: CvTemplateOutput): CvTemplate;

	public abstract cvTemplatesAsEntities(
		outputs: CvTemplateOutput[]
	): CvTemplate[];
}
